import React from "react";
import { CATEGORIES } from "./categories";
import { BANNERS } from "./banners";

export const CollectionBanner = ({ cat, count }) => {
  const c = CATEGORIES.find((x) => x.key === cat);
  const b = BANNERS[cat];
  if (!c || !b) { return null; }
  return (
    <section key={cat} className="shop-rise relative overflow-hidden rounded-3xl border border-[#D4AF37]/40 mt-8 min-h-[220px] sm:min-h-[260px]" data-testid={`collection-banner-${cat}`}>
      <img src={`/shop/cats/${cat}.jpg`} alt={c.label} className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#021A13]/95 via-[#032B20]/80 to-[#032B20]/25" />
      <div className="relative p-6 sm:p-10 max-w-2xl">
        <p className="font-arabic text-2xl text-[#FFE9A8] text-left" dir="rtl">{c.ar}</p>
        <h2 className="font-serif text-3xl sm:text-4xl font-bold text-white mt-1" data-testid="collection-banner-title">{c.label}</h2>
        <blockquote className="mt-4 border-l-2 border-[#D4AF37] pl-4" data-testid="collection-banner-quote">
          <p className="font-serif italic text-base sm:text-lg text-[#F5EFE6] leading-relaxed">“{b.quote}”</p>
          <p lang="bn" className="text-base sm:text-lg text-[#FFE9A8] leading-relaxed mt-2" style={{ fontFamily: "'Hind Siliguri', 'Noto Sans Bengali', sans-serif" }} data-testid="collection-banner-quote-bn">“{b.bn}”</p>
          <cite className="block not-italic text-xs tracking-[0.2em] uppercase text-[#D4AF37] mt-2">{b.src}</cite>
        </blockquote>
        <p className="text-xs text-[#A3B8B0] mt-4">{count} {count === 1 ? "treasure" : "treasures"} in this collection</p>
      </div>
    </section>
  );
};
